module.exports = __webpack_public_path__ + "img/roadmap.5b4d6051.png";